import type { OpenInDestination } from '../types';
import { assertExhaustive } from 'venn-utils';

export const getDestinationFriendlyName = (destination: OpenInDestination) => {
  switch (destination) {
    case 'studio':
      return 'Studio';
    case 'report_lab':
      return 'Report Lab';
    default:
      throw assertExhaustive(destination);
  }
};

export const getDestinationShortName = (destination: OpenInDestination) => {
  switch (destination) {
    case 'studio':
      return 'Studio';
    case 'report_lab':
      return 'Report';
    default:
      throw assertExhaustive(destination);
  }
};

export const getTemplateType = (destination: OpenInDestination) => {
  switch (destination) {
    case 'studio':
      return 'TEARSHEET_TEMPLATE';
    case 'report_lab':
      return 'REPORT_TEMPLATE';
    default:
      throw assertExhaustive(destination);
  }
};
